'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./plan-level.scss');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pricingLevelFeature = require('hellosign/components/pricing/pricing-level-feature');

var _pricingLevelFeature2 = _interopRequireDefault(_pricingLevelFeature);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// NOTE: If extending this to cover the general pricing case,
// we'll want to reintroduce seatBadge / oldPrice / other currently unused vals
// CF pricing-level.jsx for details

var PlanLevel = function (_React$Component) {
    _inherits(PlanLevel, _React$Component);

    function PlanLevel(props) {
        _classCallCheck(this, PlanLevel);

        var _this = _possibleConstructorReturn(this, (PlanLevel.__proto__ || Object.getPrototypeOf(PlanLevel)).call(this, props));

        _this.state = {
            expanded: _this.props.expanded || false
        };
        return _this;
    }

    /*
     * Click handling
     */

    _createClass(PlanLevel, [{
        key: 'onLevelClick',
        value: function onLevelClick() {
            this.setState({
                expanded: !this.state.expanded
            });
        }
    }, {
        key: 'onPlanChoiceButtonClick',
        value: function onPlanChoiceButtonClick() {
            this.props.onPlanChoice({
                planId: this.props.plan.plan_id,
                timePeriod: this.props.timePeriod,
                price: this.getPrice()
            });
        }

        /*
         * Utility
         */

    }, {
        key: 'getPrice',
        value: function getPrice() {
            if (this.props.coupon) {
                if (this.props.timePeriod === 'Y') {
                    return this.props.plan.coupon_annual_price;
                } else {
                    return this.props.plan.coupon_monthly_price;
                }
            } else {
                if (this.props.timePeriod === 'Y') {
                    return this.props.plan.annual_price;
                } else {
                    return this.props.plan.monthly_price;
                }
            }
        }
    }, {
        key: 'getDisplayPrice',
        value: function getDisplayPrice(price) {
            if (this.props.timePeriod === 'Y') {
                price = price / 12;
            }
            return Math.ceil(price);
        }

        /*
         * Subrenders
         */

    }, {
        key: 'renderFeatures',
        value: function renderFeatures() {
            var features = this.props.plan.features.map(function (feature, i) {
                var name = feature.name ? feature.name : name;
                var detail = feature.detail ? feature.detail : null;
                var number = feature.number ? feature.number : null;
                return _react2['default'].createElement(_pricingLevelFeature2['default'], {
                    name: name,
                    planName: this.props.name,
                    detail: detail,
                    number: number,
                    key: 'feature' + i,
                    isFree: false,
                    expanded: this.state.expanded });
            }.bind(this));
            return features;
        }
    }, {
        key: 'renderMainFeature',
        value: function renderMainFeature() {
            var mainFeature;
            if (this.props.plan.main_feature) {
                var mainFeature = this.props.plan.main_feature;
                var name = mainFeature.name ? mainFeature.name : name;
                var detail = mainFeature.detail ? mainFeature.detail : null;
                var number = mainFeature.number ? mainFeature.number : null;
                mainFeature = _react2['default'].createElement(_pricingLevelFeature2['default'], {
                    name: name,
                    planName: this.props.plan.name,
                    detail: detail,
                    number: number,
                    isFree: false,
                    key: 'main-feature',
                    expanded: this.state.expanded });
            }
            return mainFeature;
        }

        /*
         * Main render
         */

    }, {
        key: 'render',
        value: function render() {
            var mostPopular = this.props.plan.most_popular ? _react2['default'].createElement('img', { className: 'most-popular show-for-large-up', src: require('common/images/most_popular_cerulean_@2x.png') }) : '';

            var preCouponPrice = void 0;
            if (this.props.plan.coupon) {

                var oldPrice = this.props.timePeriod === 'Y' ? this.props.plan.annual_price : this.props.plan.monthly_price;

                preCouponPrice = _react2['default'].createElement(
                    'div',
                    { className: 'm-pricing-level--body small-4 large-12 small-centered columns level-price' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'dollar crossed' },
                        '$'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'price crossed' },
                        this.getDisplayPrice(oldPrice)
                    )
                );
            }

            var price = this.getDisplayPrice(this.getPrice());
            var name = this.props.plan.name;

            var period = this.props.timePeriod === 'M' ? 'per month' : 'per month when paid annually';
            var billingPeriod = _react2['default'].createElement(
                'div',
                { className: 'billing-period' },
                period
            );

            var ctaButton = _react2['default'].createElement(_button2['default'], { buttonText: 'Start 30-day Free Trial',
                onClick: this.onPlanChoiceButtonClick.bind(this),
                buttonColor: 'ashen',
                buttonHoverColor: 'cerulean' });

            var additionalFeatures = _react2['default'].createElement(
                'div',
                { className: 'additional-features small-12 columns block' },
                this.props.plan.additional_features
            );

            var levelClasses = (0, _classnames2['default'])({
                'small-5': true,
                'medium-4': true,
                'medium-offset-1': true,
                'large-12': true,
                'large-offset-0': true,
                'columns': true,
                'level-title': true
            });
            var priceClasses = (0, _classnames2['default'])({
                'hide-for-large-up': true,
                'small-7': true,
                'medium-5': true,
                'medium-offset-1': true,
                'columns': true,
                'level-price': true
            });
            var arrowContainerClasses = (0, _classnames2['default'])({
                'arrow-container': true,
                'hide-for-large-up': true,
                'hide-for-small': true,
                'small-2': true,
                'medium-1': true,
                'columns': true
            });
            var arrowClasses = (0, _classnames2['default'])({
                'l-vertical-align': true,
                'arrow': true,
                'expanded': this.state.expanded
            });
            var bodyClasses = (0, _classnames2['default'])({
                'm-pricing-level--body': true,
                'small-12': true,
                'columns': true,
                'expanded': this.state.expanded
            });
            var topLevelClasses = 'm-pricing-level signup-plan small-12 medium-12 large-4 columns';

            return _react2['default'].createElement(
                'div',
                { className: topLevelClasses },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-pricing-level--header small-12 medium-12 block', onClick: this.onLevelClick.bind(this) },
                    _react2['default'].createElement(
                        'div',
                        { className: levelClasses },
                        _react2['default'].createElement(
                            'div',
                            { className: 'level-title l-vertical-align-wrapper' },
                            _react2['default'].createElement(
                                'div',
                                { className: 'l-vertical-align' },
                                name ? name.toUpperCase() : ''
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'subheader' },
                            this.props.plan.subheader
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: priceClasses },
                        _react2['default'].createElement(
                            'div',
                            { className: 'level-title l-vertical-align-wrapper' },
                            _react2['default'].createElement(
                                'div',
                                { className: 'l-vertical-align' },
                                _react2['default'].createElement(
                                    'span',
                                    { className: 'dollar' },
                                    '$'
                                ),
                                _react2['default'].createElement(
                                    'span',
                                    { className: 'price' },
                                    price,
                                    _react2['default'].createElement(
                                        'span',
                                        { className: 'billing-period' },
                                        period
                                    )
                                )
                            )
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: arrowContainerClasses },
                        _react2['default'].createElement(
                            'div',
                            { className: 'level-title l-vertical-align-wrapper' },
                            _react2['default'].createElement(
                                'div',
                                { className: arrowClasses },
                                '\xA0'
                            )
                        )
                    ),
                    mostPopular
                ),
                _react2['default'].createElement(
                    'div',
                    { className: bodyClasses },
                    _react2['default'].createElement(
                        'div',
                        { className: 'first-section block' },
                        preCouponPrice,
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-pricing-level--body small-3 large-12 small-centered columns block' },
                            _react2['default'].createElement(
                                'div',
                                { className: 'dollar' },
                                '$'
                            ),
                            _react2['default'].createElement(
                                'div',
                                { className: 'price' },
                                price
                            ),
                            billingPeriod
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'block' },
                            ctaButton
                        ),
                        this.renderMainFeature()
                    )
                ),
                this.renderFeatures(),
                additionalFeatures
            );
        }
    }]);

    return PlanLevel;
}(_react2['default'].Component);

PlanLevel.propTypes = {
    plan: _react.PropTypes.object.isRequired,
    timePeriod: _react.PropTypes.string,
    onPlanChoice: _react.PropTypes.func
};
PlanLevel.defaultProps = {
    periodType: 'Y'
};
exports['default'] = PlanLevel;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/plan-level.jsx
 ** module id = 1143
 ** module chunks = 0
 **/